export default "__VITE_ASSET__82478913__"